import { PRICING_CONFIGS } from "@shapr3d/frontend-lib";

import messages from "../../locales/messages";

type FormatMessage = (descriptor: { id: string; defaultMessage?: string }) => string;

export function getWebAppPricingConfigs(t: FormatMessage) {
  const m = messages.PricingCards;

  return {
    free: {
      ...PRICING_CONFIGS.free,
      planName: t(m.Free.PlanName),
      tagline: t(m.Free.Tagline),
      features: [
        {
          category: "",
          items: [
            { text: t(m.Free.Feature.UpTo2Projects) },
            { text: t(m.Free.Feature.Platforms) },
            { text: t(m.Free.Feature.CloudStorage) },
            { text: t(m.Free.Feature.ImportFormats) },
            { text: t(m.Free.Feature.ExportFormats) },
            { text: t(m.Free.Feature.GenerativeRenders) },
          ],
        },
      ],
    },
    individual: {
      ...PRICING_CONFIGS.individual,
      planName: t(m.Individual.PlanName),
      tagline: t(m.Individual.Tagline),
      seatTypes: undefined,
      features: [
        {
          category: "",
          items: [
            { text: t(m.Individual.Feature.UpTo100Projects) },
            { text: t(m.Individual.Feature.Contributors) },
            { text: t(m.Individual.Feature.VersionHistory) },
            { text: t(m.Individual.Feature.ImportFormats) },
            { text: t(m.Individual.Feature.ExportFormats) },
            { text: t(m.Individual.Feature.GenerativeRenders) },
            { text: t(m.Individual.Feature.TechnicalDrawings) },
            { text: t(m.Individual.Feature.RealtimeRenders) },
            { text: t(m.Individual.Feature.AR) },
            { text: t(m.Individual.Feature.ShareLinks) },
            { text: t(m.Individual.Feature.Support) },
          ],
        },
      ],
    },
    studio: {
      ...PRICING_CONFIGS.studio,
      planName: t(m.Studio.PlanName),
      tagline: t(m.Studio.Tagline),
      priceSubline: t(m.Studio.PriceSubline),
      seatTypes: undefined,
      features: [
        {
          category: "",
          items: [
            { text: t(m.Studio.Feature.Teamspace) },
            { text: t(m.Studio.Feature.UnlimitedProjects) },
            { text: t(m.Studio.Feature.EditorSeats) },
            { text: t(m.Studio.Feature.UnlimitedDrafts) },
            { text: t(m.Studio.Feature.VersionHistory) },
            { text: t(m.Studio.Feature.ImportFormats) },
            { text: t(m.Studio.Feature.ExportFormats) },
            { text: t(m.Studio.Feature.GenerativeRenders) },
            { text: t(m.Studio.Feature.VisionPro) },
            { text: t(m.Studio.Feature.MaterialLibraries) },
            { text: t(m.Studio.Feature.MultipleSpaces) },
            { text: t(m.Studio.Feature.Support) },
          ],
        },
      ],
    },
    enterprise: {
      ...PRICING_CONFIGS.enterprise,
      planName: t(m.Enterprise.PlanName),
      planBadgeVariant: "default" as const,
      tagline: t(m.Enterprise.Tagline),
      seatTypes: undefined,
      features: [
        {
          category: "",
          items: [
            { text: t(m.Enterprise.Feature.AccessControl) },
            { text: t(m.Enterprise.Feature.VersionHistory) },
            { text: t(m.Enterprise.Feature.DataOwnership) },
            {
              text: t(m.Enterprise.Feature.DataStorage),
              subItems: [
                t(m.Enterprise.Feature.DataStorageCloudOff),
                t(m.Enterprise.Feature.DataStorageSingleTenant),
                t(m.Enterprise.Feature.DataStoragePrivateCloud),
                t(m.Enterprise.Feature.DataStorageOnPremise),
              ],
            },
            { text: t(m.Enterprise.Feature.GenerativeRenders) },
            { text: t(m.Enterprise.Feature.VisionPro) },
            { text: t(m.Enterprise.Feature.Onboarding) },
          ],
        },
      ],
    },
  };
}
